import $ from 'jquery';

$('.interferer-slider__image-inner-wrap--video').on('click', function () {
    if($(this).find('.interferer-slider__video').length < 1) {
        var youtubeId = $(this).data('youtube');
        var iframe = document.createElement('iframe');

        iframe.className = 'interferer-slider__video';
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('src', 'https://www.youtube-nocookie.com/embed/' + youtubeId + '?rel=0&showinfo=0&autoplay=1');

        $(this).append(iframe);
    }
})